import {
    FlexContainer,
    Heading,
    Icon,
    IconContainer,
    MenuText,
    Modal,
    Toast,
} from '@placer-ui/components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
    selectUpgradeYourPlanPopupIsVisible,
    selectUpgradeYourPlanPopupScreen,
} from 'store/app-ui/selectors/application-selectors-factory';
import { useAppUiActions } from 'store/app-ui/use-app-ui-actions';
import styles from './upgrade-your-plan-dialog-accessible.module.scss';
import { UpgradeYourPlanBullets } from 'extensions/upgrade-your-plan-dialog/upgrade-your-plan-dialog-accessible/components/upgrade-your-plan-bullets/upgrade-your-plan-bullets';
import { UPGRADE_PLAN_SCREEN } from 'extensions/upgrade-your-plan-dialog/upgrade-your-plan-dialog';
import { ConsultWithSalesForm } from 'extensions/upgrade-your-plan-dialog/upgrade-your-plan-dialog-accessible/components/consult-with-sales-form/consult-with-sales-form';

export const UpgradeYourPlanDialogAccessible = () => {
    const [openToast, setOpenToast] = useState(false);
    const { closeUpgradePlanPopup } = useAppUiActions();
    const upgradeYourPlanPopupVisible = useSelector(selectUpgradeYourPlanPopupIsVisible);
    const upgradeYourPlanPopupScreen = useSelector(selectUpgradeYourPlanPopupScreen);

    return (
        <>
            <Modal
                hasBackdrop
                maxHeight={'unset'}
                open={upgradeYourPlanPopupVisible}
                onOpenChange={() => closeUpgradePlanPopup()}
                trigger={<></>}
            >
                <div className={styles.root}>
                    <FlexContainer flexDirection={'column'} gap={'32px'} alignItems={'center'}>
                        <FlexContainer flexDirection={'column'} alignItems={'center'} gap={'24px'}>
                            <IconContainer shape={'circle'} color={'brand'} size={48}>
                                <Icon
                                    type={'UpsellSparkle'}
                                    color={'brand'}
                                    allowHoverState={false}
                                    size={32}
                                />
                            </IconContainer>
                            <FlexContainer
                                flexDirection={'column'}
                                alignItems={'center'}
                                gap={'8px'}
                            >
                                <Heading variant={'h3'}>Upgrade Your Plan</Heading>
                                {upgradeYourPlanPopupScreen === UPGRADE_PLAN_SCREEN.default && (
                                    <MenuText variant={'semi-bold'}>Get access to:</MenuText>
                                )}
                            </FlexContainer>
                        </FlexContainer>
                        {upgradeYourPlanPopupScreen === UPGRADE_PLAN_SCREEN.default && (
                            <UpgradeYourPlanBullets />
                        )}
                        {upgradeYourPlanPopupScreen === UPGRADE_PLAN_SCREEN.consultForm && (
                            <ConsultWithSalesForm onSubmit={() => setOpenToast(true)} />
                        )}
                    </FlexContainer>
                </div>
            </Modal>
            <Toast
                open={openToast}
                onOpenChange={setOpenToast}
                icon="approve"
                title={'Thanks for reaching out!'}
                subTitle={'One of our experts will be in touch soon'}
                duration={3000}
            >
                <Toast.CtaButton onClick={() => setOpenToast(false)}>Close</Toast.CtaButton>
            </Toast>
        </>
    );
};
